/*eslint-disable*/
export default {
    data () {
        return {
            time: 0,
            timer: null,
            timeBeforeDestroy: 0 // time for battle pause
        }
    },
    methods: {
        setTimer() {
            this.time = this.time + 1;
            this.timer = setTimeout(this.setTimer, 1000);
        },
        stopTimer () {
            clearTimeout(this.timer);
        },
        resetTimer () {
            this.stopTimer();
            this.time = 0;
            this.timer = null;
        }
    },
    computed: {
        getTime() {
            return `${Math.floor(this.time / 60) >= 10 ? '' : '0'}${Math.floor(this.time / 60)}:${this.time % 60 >= 10 ? '' : '0'}${this.time % 60}`;
        },
        getTimeWithHours() {
            const hours = Math.floor(this.time / 60 / 60);
            const minutes = Math.floor(this.time / 60);
            return `${hours >= 10 ? '' : '0'}${hours}:${(minutes - hours * 60) >= 10 
                ? '' : '0'}${minutes - hours * 60}:${this.time % 60 >= 10 ? '' : '0'}${this.time % 60}`
        }
    },
    beforeDestroy () {
        this.timeBeforeDestroy = this.time;
        this.resetTimer();
    }
}
